module.exports = __webpack_public_path__ + "a8ee32ee260d3431a63a44eed9960232.png";